<div class="row ng-scope" style="min-height:500px">

  <div class="col-4">
    <div class="row">
      <p style="line-height: 20px;float:right;padding-left:10px">
        {{'Bước 1: Tải tệp mẫu' | translate}} (<a style="color:blue" (click)="taitepmau()">{{'Tại đây' | translate}}</a>)
      </p>
      <p style="line-height: 20px;float:right;padding-left:10px">
        {{'Bước 2: Nhập dữ liệu vào tệp excel đã tải về' | translate}}
      </p>
      <p style="line-height: 20px;float:right;padding-left:10px">
        {{'Bước 3: Ấn nút "Chọn file" bên dưới để chọn tệp excel đã nhập dữ liệu' | translate}}
      </p>
      <p style="line-height: 20px;float:right;padding-left:10px">
        {{'Thông tin nhập dữ liệu hiển thị ở lưới bên trái' | translate}}
      </p>

    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="fileUpload btn btn-primary">
          <!--*ngIf="isUploadBtn"-->
          <span>{{'Chọn file' | translate}}</span>
          <input  type="file" id="btnUpload" value="Upload" (change)="fileChange($event)" class="upload" />
        </div>

        

        <!--<form>
    <input type="file" id="myfile" />
    <input type="button" (click)="uploadFile()" value="Upload" />
  </form>-->
        <!--<kendo-upload [autoUpload]="false"
                [saveUrl]="uploadSaveUrl"
                [removeUrl]="uploadRemoveUrl"
                [restrictions]="uploadRestrictions"
                (select)="selectEventHandler($event)"
                (clear)="clearEventHandler($event)"
                (remove)="removeEventHandler($event)"
                (upload)="uploadEventHandler($event)"
                (success)="successEventHandler($event)"
                (complete)="completeEventHandler($event)">

  </kendo-upload>-->
      </div>

      <div class="col-md-12">
        <span style="font-weight:bold">{{'Chi nhánh chọn dưới đây' | translate}}</span>
      </div>

      <div class="col-md-12">
        <ng-select #slChiNhanh
                   class="twcollong"
                   [tabIndex]="25"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                    placeholder="Chi nhánh"
                   [(ngModel)]="donviid">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="col-8" style="border-left:1px solid rgba(0, 0, 0, 0.12);font-size:10px">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr class="thCenter">

          <th class="thCenter">
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Ngày import' | translate}}
            </a>
          </th>
          <th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Người import' | translate}}
            </a>
          </th>
          <th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Thành công' | translate}}
            </a>
          </th>
          <th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Lỗi' | translate}}
            </a>
          </th>
         
          <th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'File nguồn' | translate}}
            </a>
          </th>
           <th style="width:100px">
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Thông báo lỗi' | translate}}
            </a>
          </th>
          <!--<th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'File lỗi' | translate}}
            </a>
          </th>-->
          <th>
            <a _ngcontent-c11="" class="ng2-smart-sort-link sort ng-star-inserted" href="#">
              {{'Chức năng' | translate}}
            </a>
          </th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let u of datas'>
          <td>{{u.Created | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          <td>{{u.CreatedBy}}</td>
          <td class="thCenter">{{u.TotalSuss}}</td>
          <td class="thCenter">{{u.TotalError}}</td>

          <td>
            <a style="color:blue;cursor:pointer" (click)='OnFileImportClick(u.Id)'>{{u.TenFileImport}}</a>
          </td>
          <td style="width:100px">
            <a *ngIf="u.Note!==null" style="color:blue;cursor:pointer;text-decoration:underline" (click)='OnThongBaoClick(u)'>Hiển thị lỗi</a>
          </td>
          <!--<td>
            <a style="color:blue;cursor:pointer" (click)='OnFileErrorClick(u.Id)'>{{u.TenFileError}}</a>
          </td>-->
          <td><a style="color:blue;cursor:pointer" (click)='deletedata(u.Id)'><i class="mb-1 far fa-trash-alt"> {{'Xóa' | translate}}</i></a></td>

        </tr>
      </tbody>

    </table>
  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
        <div class="">
                
            </div>
    <div class="">
        
    </div>
    
</div>


<bs-modal #ThongbaoImport class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thông báo</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="ThongbaoImport.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <table *ngIf="rowThongbao.length > 0" border="1">
      <thead>
        <tr>
          <th>Họ và tên</th>
          <th>Trạng thái lỗi</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of rowThongbao; let i = index">
          <td>{{ item.HoVaTen }}</td>
          <td>{{ item.ThongBao }}</td>
        </tr>
      </tbody>
    </table>
  </bs-modal-body>
</bs-modal>
